var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBitcoinCash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3{fill:#8cc351;}.cls-4{fill:#aad875;}.cls-5{fill:#fefffe;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 30,
    height: 30
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bitcoin"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_51",
    "data-name": "Layer 51"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14",
    "data-name": "Group 14"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6",
    "data-name": "Rectangle 6",
    className: "cls-3",
    width: 30,
    height: 30,
    rx: 7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Intersection_1",
    "data-name": "Intersection 1",
    className: "cls-4",
    d: "M0,7A7,7,0,0,1,7,0h6.51a16.19,16.19,0,0,1,.82,5.12A16.39,16.39,0,0,1,0,21.37Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M8.3,9.46l.57-.16.5-.13c.11,0,.11,0,.08-.15-.1-.38-.21-.76-.31-1.14,0-.15,0-.15.1-.19l1.95-.53c.11,0,.11,0,.14.09.11.38.21.77.32,1.16,0,.12,0,.12.16.09L14,7.91c.14,0,.14,0,.1-.19l-.3-1.13c0-.13,0-.13.09-.16l1.95-.54c.11,0,.12,0,.15.09.15.55.31,1.09.45,1.63a.22.22,0,0,0,.19.19,3.8,3.8,0,0,1,1.66.75,3.42,3.42,0,0,1,1.21,1.83A3.48,3.48,0,0,1,19.26,13s0,.07,0,.11,0,0,0,0,.09,0,.13.06a3.67,3.67,0,0,1,2.13,2.15,3.59,3.59,0,0,1-.16,2.92,4,4,0,0,1-1.37,1.56c-.15.1-.15.1-.1.26l.54,2c.06.21.06.21-.15.26l-1.82.5h0c-.13,0-.14,0-.17-.1L18,22l-.33-1.19s0-.08-.05-.11l-1,.27-1.28.35c-.17,0-.17,0-.12.22.17.64.35,1.28.52,1.92,0,.13,0,.13-.09.16l-1.92.52-.06,0c-.07,0-.1,0-.12-.07l-.19-.7c-.13-.45-.25-.91-.38-1.36,0-.11,0-.11-.13-.08l-1.35.37c-.12,0-.13,0-.16-.08-.16-.61-.33-1.21-.49-1.81,0-.14,0-.15.1-.18l1.3-.36c.18-.05.15,0,.1-.18-.23-.87-.47-1.75-.71-2.62-.31-1.12-.61-2.24-.92-3.36l-.64-2.35c0-.12,0-.12-.16-.09L9,11.5c-.14,0-.14,0-.18-.1-.16-.62-.33-1.23-.5-1.85C8.3,9.53,8.28,9.51,8.3,9.46Zm11.13,7.21a1.64,1.64,0,0,0-1.27-1.59,2,2,0,0,0-1,.05l-1.45.44c-.6.18-1.2.33-1.81.5-.14,0-.14,0-.1.17.25.94.51,1.89.77,2.83.06.22,0,.18.24.13l3.39-.93A1.7,1.7,0,0,0,19.43,16.67ZM15.51,9.84a2.31,2.31,0,0,0-.74.08l-2.4.65c-.12,0-.12,0-.09.15l.3,1.1c.19.69.38,1.38.56,2.06,0,.12,0,.12.15.08L15,13.51A5.39,5.39,0,0,0,16,13.16,3.37,3.37,0,0,0,17,12.5,1.57,1.57,0,0,0,16.46,10,2.2,2.2,0,0,0,15.51,9.84Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBitcoinCash);
export default __webpack_public_path__ + "static/media/bitcoin-cash.e9843a79bc007d3f2901e8f773de5707.svg";
export { ForwardRef as ReactComponent };